<template>
  <div class="carddraw-module">
    <div class="k-carddraw" :style="aStyle">
      <div
        class="lottery-num"
        :style="{
          fontSize: `${$unit(num.fontSize)}`,
          color: `${num.fontColor}`,
          bottom: `${$unit(num.bottom)}`
        }"
      >
        剩余{{ prizeNum || 0 }}次抽奖机会
      </div>
      <div
        class="btn-history"
        :style="{
          fontSize: `${$unit(history.fontSize)}`,
          color: `${history.fontColor}`,
          bottom: `${$unit(history.bottom)}`
        }"
        @click="openPrizeRecord"
      >
        查看中奖记录
      </div>
      <base-carddraw
        class="wrapper"
        ref="cardDrawPrize"
        :style="{
          bottom: `${$unit(draw.bgBottom)}`,
          right: `${$unit(draw.bgLeft)}`,
          left: `${$unit(draw.bgLeft)}`
        }"
        :draw="draw"
        @end-turns="endTurns"
        @start-turns="startTurns"
      >
        <template slot="item" slot-scope="scope">
          <img :src="scope.item"
        /></template>
      </base-carddraw>
    </div>
    <div class="marquee-box" :style="pStyle" v-if="marquee.scrollSwitch">
      <div
        class="marquee-scroll"
        :style="{
          bottom: `${$unit(marquee.bottom)}`
        }"
      >
        <scroll-marquee
          :speed="10"
          :standTime="2000"
          :list="scrollPrizes"
          :marquee="marquee"
        >
        </scroll-marquee>
      </div>
    </div>
    <CardEffect :img="draw.bg || defaultBg" v-if="state.isShowDialogEffect" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseCarddraw from './BaseCarddraw.vue';
import ScrollMarquee from '../McLuckdraw/ScrollMarquee.vue';
const muduleBgHeight = 546;
export default {
  name: 'McCard',
  props: {
    imageValue: {
      type: Object,
      default: () => {}
    },
    draw: {
      type: Object,
      default: () => {}
    },
    list: {
      type: Array,
      default: () => []
    },
    view: {
      type: Object,
      default: () => {}
    },
    marquee: {
      type: Object,
      default: () => {}
    },
    num: {
      type: Object,
      default: () => {}
    },
    history: {
      type: Object,
      default: () => {}
    },
    drawNumber: {
      type: Number,
      default: () => null
    },
    moduleId: {
      type: Number
    },
    viewStatus: {
      type: Number
    }
  },
  data() {
    return {
      height: muduleBgHeight,
      pHeight: 200,
      defaultModuleBg:
        'https://cdn-tx-admin-test.3kwan.com/2023/07/12/0c58a6f6a89352cb092161966bd5beec.jpg',
      defaultMarquee:
        'https://yxfile.3k.com/2023/03/15/upload_jmh38yz8aqyoiya0cxgmggcingwn63me.jpg',
      defaultBg:
        'https://cdn-tx-admin-test.3kwan.com/2023/07/12/b1680c9bde6f31f2de753181de9f391a.jpg',
      // 用来锁定转盘，避免同时多次点击转动
      prizeNum: 0,
      lock: false,
      scrollPrizes: []
    };
  },
  components: {
    BaseCarddraw,
    ScrollMarquee,
    CardEffect: () => import('./CardEffect.vue')
  },
  computed: {
    state() {
      return this.$store.state;
    },
    ...mapGetters(['prize']),
    aStyle() {
      return {
        height: this.$unit(this.height),
        backgroundImage: `url(${
          this.imageValue.imagePath || this.defaultModuleBg
        })`
      };
    },
    pStyle() {
      return {
        height: this.$unit(this.pHeight),
        backgroundImage: `url(${this.marquee.scrollBg || this.defaultMarquee})`
      };
    }
  },
  watch: {
    imageValue() {
      this.init();
    },
    marquee() {
      this.initMarquee();
    },
    'view.ext_params.draw_number': {
      deep: true,
      handler() {
        this.prizeNum = this.view.ext_params.draw_number;
      }
    }
  },
  mounted() {
    this.init();
    this.initMarquee();
    if (this.viewStatus == 2) {
      this.prizeNum = this.drawNumber;
      if (this.marquee.scrollSwitch) {
        this.getModulePrizeRecord();
      }
    } else {
      this.scrollPrizes = [
        { role_name: '测试用户1', prize_name: '测试奖品1' },
        { role_name: '测试用户2', prize_name: '测试奖品2' }
      ];
    }
  },
  methods: {
    init() {
      let img = new Image();
      img.onload = () => {
        let h = img.height;
        this.height = h;
      };
      img.onerror = () => {
        this.height = muduleBgHeight;
      };
      img.src = this.imageValue.imagePath;
    },
    initMarquee() {
      let img = new Image();
      img.onload = () => {
        let h = img.height;
        this.pHeight = h;
      };
      img.src = this.marquee.scrollBg;
    },
    startTurns() {
      // this.$refs.cardDrawPrize.runAni();
      if (this.viewStatus != 2) return;
      if (this.state.userInfo.guid === '') {
        this.$store.commit('OPEN_DIALOG', 'Guid');
        return false;
      }
      if (!this.canBeRotated()) {
        return false;
      }
      this.lock = true;
      this.drawPrize();
    },
    //请求服务端抽奖
    async drawPrize() {
      let { code, data } = await this.$api.prize.drawPrize({
        module_id: this.moduleId,
        guid: this.state.userInfo.guid,
        server_id: this.state.userInfo.server_id,
        role_id: this.state.userInfo.role_id
      });
      if (code !== 0) {
        this.lock = false;
        return;
      }
      this.Track(4, this.moduleId);
      this.$store.commit('UPDATE_PRIZE', data);
      //告诉子组件，开始转动了
      this.$refs.cardDrawPrize.runAni();
      // 成功后次数减少一次
      this.prizeNum--;
    },
    endTurns() {
      // 中奖
      this.$store.commit('OPEN_DIALOG', 'Prize');
      // 解锁
      this.lock = false;
      //更新中奖播报
      if (this.marquee.scrollSwitch) {
        this.getModulePrizeRecord();
      }
    },
    canBeRotated() {
      if (this.prizeNum <= 0) {
        this.toast('已经没有次数了！');
        return false;
      }
      if (this.lock) {
        return false;
      }
      return true;
    },
    // 查看中奖记录
    openPrizeRecord() {
      if (this.viewStatus == 2) {
        if (this.state.userInfo.guid == '') {
          this.$store.commit('OPEN_DIALOG', 'Guid');
        } else {
          this.$store.commit('UPDATE_MODULE_ID', this.moduleId);
          this.$store.commit('OPEN_DIALOG', 'PrizeRecord');
        }
      }
    },
    // 获取活动模块中奖记录
    async getModulePrizeRecord() {
      let { code, data } = await this.$api.prize.getModulePrizeRecord({
        module_id: this.moduleId
      });
      if (code !== 0) return;
      this.scrollPrizes = data;
    }
  }
};
</script>

<style lang="scss" scoped>
.k-carddraw {
  position: relative;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: 499;
}
.lottery-num {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 150px;
  font-size: 22px;
  color: #e5e5e5;
  text-align: center;
}
.btn-history {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 60px;
  font-size: 22px;
  color: #f8db83;
  text-align: center;
  text-decoration: underline;
}
.marquee-box {
  position: relative;
  height: 200px;
  background-size: cover;
  background-repeat: no-repeat;
  .marquee-scroll {
    width: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 50px;
  }
}
.wrapper {
  position: absolute;
}
</style>
